import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { TimelineCellRenderer$key } from '@atlassian/jira-relay/src/__generated__/TimelineCellRenderer.graphql';
import { useTimelineCustomComponents } from '../../../../controllers/timeline-custom-components/index.tsx';

export type TimelineCellProps = {
	depth: number;
	groupId?: string;
	fieldRef: TimelineCellRenderer$key;
};

export const TimelineCellRenderer: FC<TimelineCellProps> = ({ depth, groupId, fieldRef }) => {
	const timelineCustomComponents = useTimelineCustomComponents();

	const data = useFragment<TimelineCellRenderer$key>(
		graphql`
			# eslint-disable-next-line @atlassian/relay/fragment-naming-convention
			fragment TimelineCellRenderer on JiraIssueField
			@argumentDefinitions(isTimelineEnabled: { type: "Boolean!" }) {
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...TimelineCell @include(if: $isTimelineEnabled)
			}
		`,
		fieldRef,
	);

	return (
		timelineCustomComponents?.Cell && (
			<timelineCustomComponents.Cell depth={depth} groupId={groupId} fieldRef={data} />
		)
	);
};
